import { render } from "./ModalObservaciones.vue?vue&type=template&id=20f6bbfc"
import script from "./ModalObservaciones.vue?vue&type=script&lang=js"
export * from "./ModalObservaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__